import { useTranslation } from "react-i18next";
import { useGetCurrentUser } from "@workspace/api-client-react";
import { Button } from "@/components/ui/button";

export function AccessVerificationRetry() {
  const { t } = useTranslation();
  const { refetch, isFetching } = useGetCurrentUser();
  return <div className="mx-auto max-w-lg space-y-4 p-8 text-center">
    <p role="alert">{t("billing.verificationUnavailable")}</p>
    <Button disabled={isFetching} onClick={() => void refetch()}>{t("billing.retry")}</Button>
  </div>;
}